module.exports = __webpack_public_path__ + "assets/images/b4f0daac03d20b68f7737dc1634e9d36.png";